import React, {
  FocusEventHandler,
  KeyboardEventHandler,
  MouseEventHandler,
  ReactNode,
  createElement,
} from 'react';
import styled from 'styled-components';
// eslint-disable-next-line import/no-namespace
import * as ss from 'styled-system';
import {
  HeightProps,
  MarginProps,
  MaxHeightProps,
  MaxWidthProps,
  MinHeightProps,
  MinWidthProps,
  PaddingProps,
  WidthProps,
} from 'styled-system';

import { useTabContext } from 'containers/TabContext';

type Props = {
  as?: React.ComponentType | React.ElementType;
  children?: ReactNode;
  component?: React.ComponentType | React.ElementType;
  className?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  color?: string;
  bg?: string;
  fontSize?: string;
  fontWeight?: string | number;
  borderRadius?: string | number;
  border?: string;
  borderLeft?: string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  href?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  onFocus?: FocusEventHandler<HTMLButtonElement>;
  onBlur?: FocusEventHandler<HTMLButtonElement>;
  onKeyUp?: KeyboardEventHandler<HTMLButtonElement>;
  title?: string;
  tabIndex?: number;
  name?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  disabled?: any;
} & MarginProps &
  PaddingProps &
  WidthProps &
  MinWidthProps &
  MaxWidthProps &
  HeightProps &
  MinHeightProps &
  MaxHeightProps;

const StyledButton = styled(
  ({
    as,
    component,
    type = 'button',
    isTabbing,
    m,
    mt,
    mr,
    mb,
    ml,
    mx,
    my,
    p,
    pt,
    pr,
    pb,
    pl,
    px,
    py,
    display,
    alignItems,
    justifyContent,
    width,
    height,
    minWidth,
    minHeight,
    color,
    bg,
    fontSize,
    fontWeight,
    borderRadius,
    border,
    disabled,
    ...otherProps
  }: Props & { isTabbing: boolean }) => {
    const props = { ...otherProps, disabled: Boolean(disabled) };

    if (as) {
      return createElement(as, props);
    }

    if (component) {
      return createElement(component, props);
    }

    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/jsx-props-no-spreading, react/button-has-type
    return <button {...props} type={type} />;
  }
)<{ $transparent: boolean }>`
  padding: 0;
  appearance: none;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
  font-size: inherit;
  font-weight: inherit;
  &[disabled] {
    cursor: auto;
  }
  ${(props) =>
    !props.isTabbing &&
    `
    outline: 0;
  `}
  ${ss.size} ${ss.display} ${ss.space} ${ss.width} ${ss.height} ${ss.minWidth} ${ss.minHeight} ${ss.fontSize} ${ss.fontWeight} ${ss.borderRadius} ${ss.color} ${ss.border}
`;

export function Button(props: Props) {
  const isTabbing = useTabContext();

  return (
    <StyledButton
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      isTabbing={isTabbing}
    />
  );
}
